import { render, staticRenderFns } from "./DiscountSwitchConnection.vue?vue&type=template&id=f75c1e18&scoped=true&"
import script from "./DiscountSwitchConnection.vue?vue&type=script&lang=js&"
export * from "./DiscountSwitchConnection.vue?vue&type=script&lang=js&"
import style0 from "./DiscountSwitchConnection.vue?vue&type=style&index=0&id=f75c1e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75c1e18",
  null
  
)

export default component.exports